<template>
  <v-form v-model="valid" ref="form">
    <p class="body-1 grey--text text--darken-1 mt-4">
      {{ $t("label.yourApproval") }}
    </p>
    <v-card class="pa-3">
      <v-card-text>
        <p>{{ message }}</p>
        <v-layout row>
          <v-flex>
            <v-text-field
              multi-line
              v-model="form.comments"
              auto-grow
              :counter="constants.LENGTH_COMMENTS"
              :maxlength="constants.LENGTH_COMMENTS"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row v-show="form.files.length > 0" class="mt-3">
          <v-flex>
            <app-files
              :files.sync="form.files"
              :removedFiles.sync="form.removedFiles"
              :removeable="true"
            ></app-files>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="success"
          :loading="approving"
          :disabled="rejecting || disableApprovalButton"
          @click="approve"
          >{{ $t("label.approve") }}</v-btn
        >
        <app-file-upload
          :disabled="approving || rejecting"
          :model.sync="form.files"
        ></app-file-upload>
        <v-btn
          color="warning"
          :loading="rejecting"
          :disabled="approving || disableRejectButton"
          @click="reject"
          >{{ $t("label.reject") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import constants from "@/helpers/constants";
import FileUpload from "@/components/shared/FileUpload";
import Files from "@/components/shared/Files";
import Demand from "@/helpers/entities/Demand";

import moment from "moment";

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      constants,
      valid: true,
      approving: false,
      rejecting: false,

      form: Demand.approval.build(),
    };
  },

  computed: {
    demand() {
      return this.$store.getters.demand;
    },
    disableApprovalButton() {
      const dataAtual = moment().startOf("day");
      const dataAprovacao = moment(
        this.demand.maximumApprovalDeliveryDate
      ).startOf("day");

      if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 4) {
        return true;
      }
      if (!this.demand.dtImplementation && this.demand.status.id === 7 &&
         this.demand.supplier.id === 1) {
        return true;
      }

      return false;
    },
    disableRejectButton() {
      const dataAtual = moment().startOf("day");
      const dataAprovacao = moment(
        this.demand.maximumApprovalDeliveryDate
      ).startOf("day");

      // When the maximum approval date is in the past and status is 4,
      // keep Reject ENABLED (i.e., do not disable the button)
      if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 4) {
        return false;
      }

      // For other conditions, reuse the same disabling logic as approval
      return this.disableApprovalButton;
    },
  },

  components: {
    appFileUpload: FileUpload,
    appFiles: Files,
  },

  mounted() {
    this.form = Demand.approval.copy(this.demand);
    console.log();
  },

  methods: {
    async approve() {
      if (!this.$refs.form.validate()) return;

      try {
        this.approving = true;
        await this.$store.dispatch("approveDemand", this.form);
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        if (error.data && error.data.code === "generic_error") {
          this.approving = false;
        } else {
          throw error;
        }
      }
    },
    async reject() {
      if (!this.$refs.form.validate()) return;

      this.rejecting = true;
      await this.$store.dispatch("rejectDemand", this.form);
      this.$router.push({ name: "dashboard" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/demands/shared/Approve.vue